// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear-value[data-v-28a73268]{position:absolute;display:inline-block;top:-1px;right:-24px}", ""]);
// Exports
module.exports = exports;
